module.exports = __webpack_public_path__ + "static/media/JOINT-PAIN-1920X1060.05d4c5ba.jpg";